import React, { ChangeEvent, Dispatch, SetStateAction, useEffect, useState } from 'react'

//** */ MUI Imports
import { Button, Switch } from '@mui/material'

// ** Child Imports
import { useLocale } from 'src/lib/hooks/useLocal'
import { useRouter } from 'next/router'
import { useRtoSuiteContext } from 'src/lib/contexts/RTOSuiteProvider'
import { PlusSquare } from 'react-feather'
import { useRTOSuitePermissions } from 'src/lib/access-permission-hooks/useRTOSuitePermissions'
import { classNames } from 'src/lib/utils/helpers'

// eslint-disable-next-line @typescript-eslint/no-empty-interface

const CODToPrepaid = () => {
  const { t } = useLocale()
  const router = useRouter()
  const c2pConfig = useRtoSuiteContext(context => context.state?.isC2pEnabled)
  const setC2pConfig = useRtoSuiteContext(context => context.actions?.setC2pConfig)

  const isDiscountEdit = useRtoSuiteContext(context => context?.state?.discountConfig?.isDiscountEdit)
  const discountId = useRtoSuiteContext(context => context?.state?.discountConfig?.discountId)
  const discounstDescription = useRtoSuiteContext(context => context?.state?.discountConfig?.discounstDescription)

  const { canEditRTOSuite } = useRTOSuitePermissions()

  // ** Alert Handlers ** //

  return (
    <div className='py-4'>
      <div className='flex flex-row justify-between items-center' data-track-id='cod-to-prepaid-header'>
        <h2 className='font-medium text-carbon text-base'>{t('cod_to_prepaid_conversion_discount')}</h2>
        {isDiscountEdit ? (
          <Switch
            name='Toggler'
            disabled={!canEditRTOSuite}
            checked={c2pConfig}
            onChange={() => {
              setC2pConfig(!c2pConfig)
            }}
          />
        ) : (
          <Button
            variant='contained'
            disabled={!canEditRTOSuite}
            sx={{ height: '36px' }}
            onClick={() => router.push('/discounts/create-c2p-discount')}
          >
            <div className='flex flex-row'>
              <PlusSquare style={{ height: 20, width: 18, marginRight: '4px' }} />
              {t('create_discount')}
            </div>
          </Button>
        )}
      </div>

      {isDiscountEdit ? (
        <div className='pt-2'>
          <div className='flex items-center justify-between p-2 border rounded border-gray-light'>
            {discounstDescription?.length ? (
              <span className='text-sm pl-4 font-medium text-gray-dark'>{discounstDescription}</span>
            ) : (
              <></>
            )}
            <button
              id='edit-btn-c2p'
              disabled={!canEditRTOSuite}
              className={classNames(
                'font-semibold h-9 rounded-lg py-2 px-3 text-sm border-2',
                c2pConfig
                  ? 'hover:ring-1 hover:ring-coal-lighter transition-all duration-200'
                  : 'opacity-50 !cursor-not-allowed'
              )}
              onClick={() => {
                if (!c2pConfig) return
                router.push(`/discounts/edit-c2p-discount?discountId=${discountId}`)
              }}
            >
              {t('edit')}
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  )
}

export default CODToPrepaid
